<template>
  <div class="needs_list">
    <ul>
      <li @click="toDetail(item)" v-for="(item, index) in list" :key="index">
        <p>{{ item.title }}</p>
        <p>截止时间：{{ item.endDate }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
    },
  },
  methods: {
    toDetail(item) {
      this.$router.push({
        path: "/demand_detail",
        query: { id: item.id },
      });
    },
  },
};
</script>

<style scoped lang='less'>
.needs_list {
  ul {
    li {
      cursor: pointer;
      padding: 10px;
      margin: 10px 0;
      border-bottom: 1px dashed #e1e1e1;
      &:last-of-type {
        border-bottom: 0;
        margin-bottom: 0;
      }
      p {
        &:nth-of-type(1) {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          margin-bottom: 5px;
        }
        &:nth-of-type(2) {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/needsList.vue